module.exports = __webpack_public_path__ + "img/qr_code.7ebcce2e.png";